import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '@avla/ui-design';
import { NOT_CONFIG, ROUTESPATH } from '@core/config/constants';
import { TokenService } from '@services';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  private __timingClose: number = 500;
  private __errorTitle: string = '¡Error!';
  private __warnTitle: string = '¡Advertencia!';
  private __infoTitle: string = '¡Información!';
  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private tokenService: TokenService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(req).pipe(
      map((evt: HttpEvent<any>) => {
        if (evt instanceof HttpResponse) {
          if (evt.body.data && Array.isArray(evt.body.data) && evt.body.data.length > 0) {
            for (const b of evt.body.data) {
              const type = b.type as
                | ''
                | 'WARN'
                | 'ERROR'
                | 'SUCCESS'
                | 'INFO';
              let title =
                type === 'ERROR'
                  ? this.__errorTitle
                  : type === 'WARN'
                  ? this.__warnTitle
                  : this.__infoTitle;
              let icon =
                type === ''
                  ? NOT_CONFIG.ICON_INFO_NOT
                  : NOT_CONFIG[`ICON_${type}_NOT`];
              let theme =
                type === 'ERROR'
                  ? NOT_CONFIG.THEME_ERROR_NOT
                  : type === 'WARN'
                  ? NOT_CONFIG.THEME_WARN_NOT
                  : NOT_CONFIG.THEME_INFO_NOT;
              this.notificationService.openNotification({
                title,
                message: b.message,
                isOpen: true,
                position: NOT_CONFIG.POSITION,
                icon,
                theme,
                iconClose: NOT_CONFIG.ICON_CLOSE_NOT,
              });
            }
          }
        }
        return evt;
      }),
      catchError((err: any) => {
        const ERROR_GENERIC_PATTERN = 'GENERIC_ERROR';
        const INVALID_CAPTCHA_PATTERN = 'INVALID_CAPTCHA';
        if (err instanceof HttpErrorResponse) {
          if (err.error?.payload === ERROR_GENERIC_PATTERN) {
            setTimeout(() => {
              this.notificationService.openNotification({
                title: this.__errorTitle,
                message:
                  'Ha ocurrido un error inesperado en el servidor. Por favor intenta más tarde',
                isOpen: true,
                position: NOT_CONFIG.POSITION,
                icon: NOT_CONFIG.ICON_ERROR_NOT,
                theme: NOT_CONFIG.THEME_ERROR_NOT,
                iconClose: NOT_CONFIG.ICON_CLOSE_NOT,
              });
            }, this.__timingClose);
            return throwError(() => err);
          } else if (err.error?.errorCode === INVALID_CAPTCHA_PATTERN) {
            setTimeout(() => {
              this.notificationService.openNotification({
                title: this.__warnTitle,
                message:
                  'Ha ocurrido un error inesperado en el servidor. Por favor intenta más tarde',
                isOpen: true,
                position: NOT_CONFIG.POSITION,
                icon: NOT_CONFIG.ICON_WARN_NOT,
                theme: NOT_CONFIG.THEME_WARN_NOT,
                iconClose: NOT_CONFIG.ICON_CLOSE_NOT,
              });
            }, this.__timingClose);
            return of(err);
          } else if (
            err.status === 400 &&
            err.error.payload?.title &&
            err.error.payload?.subtitle
          ) {
            return throwError(() => err.error.payload);
          } else if (err.status === 400 && !Array.isArray(err.error.payload)) {
            setTimeout(() => {
              this.notificationService.openNotification({
                title: this.__warnTitle,
                message: err.error.payload,
                isOpen: true,
                position: NOT_CONFIG.POSITION,
                icon: NOT_CONFIG.ICON_WARN_NOT,
                theme: NOT_CONFIG.THEME_WARN_NOT,
                iconClose: NOT_CONFIG.ICON_CLOSE_NOT,
              });
            }, this.__timingClose);
            return throwError(() => err);
          } else if (err.status === 400 && Array.isArray(err.error.payload)) {
            setTimeout(() => {
              this.notificationService.openNotification({
                title: this.__warnTitle,
                message: 'Debes revisar los datos que estás ingresando',
                isOpen: true,
                position: NOT_CONFIG.POSITION,
                icon: NOT_CONFIG.ICON_WARN_NOT,
                theme: NOT_CONFIG.THEME_WARN_NOT,
                iconClose: NOT_CONFIG.ICON_CLOSE_NOT,
              });
            }, this.__timingClose);
            return throwError(() => err);
          } else if (err.status > 403 && err.status <= 503) {
            setTimeout(() => {
              this.notificationService.openNotification({
                title: this.__errorTitle,
                message:
                  'Tenemos problemas para ejecutar la acción deseada. Por favor intenta más tarde',
                isOpen: true,
                position: NOT_CONFIG.POSITION,
                icon: NOT_CONFIG.ICON_ERROR_NOT,
                theme: NOT_CONFIG.THEME_ERROR_NOT,
                iconClose: NOT_CONFIG.ICON_CLOSE_NOT,
              });
            }, this.__timingClose);
            return throwError(() => err);
          } else if ([401, 403].includes(err.status)) {
            this.tokenService.resetToken(false);
            this.router.navigate([ROUTESPATH.LOGIN]);
            return of(err);
          } else {
            if (err.status === 0 && err.statusText === 'Unknown Error') {
              setTimeout(() => {
                this.notificationService.openNotification({
                  title: this.__errorTitle,
                  message:
                    'Tenemos problemas para ejecutar la acción deseada. Por favor intenta más tarde',
                  isOpen: true,
                  position: NOT_CONFIG.POSITION,
                  icon: NOT_CONFIG.ICON_ERROR_NOT,
                  theme: NOT_CONFIG.THEME_ERROR_NOT,
                  iconClose: NOT_CONFIG.ICON_CLOSE_NOT,
                });
              }, this.__timingClose);
              return of(err);
            }
            return throwError(() => err);
          }
        } else {
          setTimeout(() => {
            this.notificationService.openNotification({
              title: this.__errorTitle,
              message:
                'Ha ocurrido un error inesperado en el servidor. Por favor intenta más tarde',
              isOpen: true,
              position: NOT_CONFIG.POSITION,
              icon: NOT_CONFIG.ICON_ERROR_NOT,
              theme: NOT_CONFIG.THEME_ERROR_NOT,
              iconClose: NOT_CONFIG.ICON_CLOSE_NOT,
            });
          }, this.__timingClose);
          return throwError(() => err);
        }
      })
    );
  }
}
